import { userHasRequiredGroups } from '../utils/userHasRequiredGroups';
import { userIsAuthorizedForBuzz } from '../utils/userIsAuthorizedForBuzz';
import { useCurrentUserGroups } from './useCurrentUserGroups';

/**
 * Hook that will define whether or not the currently logged in user is authorized accourding to the `requiredGroups` property.
 * @param requiredGroups List of groups of which the current user must be a part of at least one.
 */
export function useRequiredCurrentUserGroups(requiredGroups) {
  const {
    userGroups,
    isLoading: userGroupsLoading
  } = useCurrentUserGroups();
  const isAuthorizedForBuzz = userIsAuthorizedForBuzz(userGroups);
  const isAuthorizedForRequiredGroups = userHasRequiredGroups(userGroups, requiredGroups);
  if (isAuthorizedForBuzz) {
    userHasRequiredGroups(userGroups, requiredGroups);
  }
  const isLoading = userGroupsLoading;
  return {
    isAuthorizedForRequiredGroups,
    isAuthorizedForBuzz,
    userGroups,
    isLoading
  };
}